import { useState } from 'react';
import { Outlet, Navigate, useParams } from 'react-router-dom';
import { Topbar } from './Topbar';
import { Sidebar } from './Sidebar';
import { OfflineBanner } from './OfflineBanner';
import { useAuth } from '../context/AuthContext';

export function Layout() {
  const { state, ready, isClientOwnerOnly } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { tenantId } = useParams();

  // Tant que la session sauvegardée n'a pas fini d'être restaurée, on
  // n'affiche rien plutôt que de rediriger prématurément vers /login.
  if (!ready) return null;

  if (!state.token) return <Navigate to={`/${tenantId}/login`} replace />;

  // La société dans l'URL ne correspond pas à la société de la session en
  // cours (ex. lien partagé, ancien onglet) : on force une reconnexion sur
  // la bonne société plutôt que de laisser voir les données d'une autre.
  if (state.tenant && tenantId && state.tenant !== tenantId) {
    return <Navigate to={`/${tenantId}/login`} replace />;
  }

  return (
    <div className="dash-view">
      <Topbar onHamburger={() => setSidebarOpen(true)} />
      <OfflineBanner />
      <div className="appbody">
        {!isClientOwnerOnly && (
          <>
            <div
              className={'sidebar-backdrop' + (sidebarOpen ? ' open' : '')}
              onClick={() => setSidebarOpen(false)}
            />
            <Sidebar open={sidebarOpen} onNavigate={() => setSidebarOpen(false)} />
          </>
        )}
        <div className="content">
          <div className="main">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}
